import { PHOTO_URL } from "@zmedia/bm-soccer-ui/constants";
import { Logger } from "./logger";

export function isSupportWebp() {
    if (typeof window !== 'undefined') {
        const _window: any = window;
        if (typeof _window.isSupportWebp !== 'undefined') {
            return _window.isSupportWebp;
        }
        else {
            const elem = document.createElement('canvas');
            if (!!(elem.getContext && elem.getContext('2d'))) {
                try {
                    const isSupport = elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
                    _window.isSupportWebp = isSupport;
                    return isSupport
                } catch (error) {
                    Logger.errorWithType('webp', 0, 'Error load Webp fail', error);
                    _window.isSupportWebp = false;
                    return false;
                }

            }
        }
    }
    return false;
}

export const convertToWebp = (src: string) => {
    if (src.indexOf(PHOTO_URL) > -1 && src.indexOf('.jpg') > -1) {
        return src + '.webp';
    }
    return src;
}


export const convertGifToJpg = (src: string) => {
    const isGif = src.slice(-4) === '.gif';
    if (isGif) {
        src = src + '.jpg';
    }
    return src;
}